export default function PageHero({ label, title, subtitle }) {
  return (
    <section className="relative pt-40 pb-20 md:pt-48 md:pb-28 bg-forest text-bone overflow-hidden grain">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16 relative z-10">
        <p className="fade-up text-xs uppercase tracking-[0.3em] text-gold mb-6" style={{ animationDelay: "0.05s" }}>
          {label}
        </p>
        <h1 className="fade-up font-serif text-5xl md:text-7xl lg:text-8xl tracking-tighter leading-[0.9]" style={{ animationDelay: "0.15s" }}>
          {title}
        </h1>
        {subtitle && (
          <p className="fade-up mt-8 max-w-2xl text-lg text-bone/60 leading-relaxed" style={{ animationDelay: "0.28s" }}>
            {subtitle}
          </p>
        )}
      </div>
      <div className="absolute -right-20 -bottom-24 w-[400px] h-[400px] rounded-full bg-forest-500/40 blur-3xl" />
    </section>
  );
}
